export const presentation = {
  intro: "Hi, I'm Ellen.",
  paragraphs: [
    'A web developer obsessed with most things UX. Passionate about clean, readable, testable code, and elegant user-friendly interfaces. I also have a Bachelor of Fine Arts.',
    'Fan of typed systems and encapsulated components, who really enjoys figuring out how to build scalable front-end architecture.',
    "When I don't write code I like to spend my time drawing, making clay candleholders, going to exhibitions or having dinner with friends.",
  ],
}

export const infoAboutMe = [
  {
    label: 'Currently',
    value: 'Tink',
    location: 'Stockholm',
    link: 'https://tink.com/',
  },
  {
    label: 'Previously',
    value: 'Hedvig',
    link: 'https://hedvig.com/',
  },
]
